export default __webpack_public_path__ + "static/media/uparr.e15a5dc2.png";